import { Grid } from '@mui/joy'
import { useGate, useStore, useStoreMap } from 'effector-react'
import { Form, promotionModel } from '~/entities/Promotion'
import { usePermissions } from '~/entities/viewer'
import {
  transmissionLabels,
  fuelTypeLabels,
  categoryAutoLabels,
  categoryAutoLabelToEnum,
  OptionEnum,
} from '~/shared/config/constants'
import {
  TransmissionEnum,
  FuelTypeEnum,
  CategoryAutoEnum,
} from '~/shared/config/enums'
import { $promotion, formSubmitted } from './model'

type EditPromotionProps = {
  promotionId: string
}

export const EditPromotion = ({ promotionId }: EditPromotionProps) => {
  useGate(promotionModel.Gate, { promotionId })
  const { canPromocodesUpdate } = usePermissions()

  const isLoading = useStore(promotionModel.requestFx.pending)
  const isSaving = useStore(promotionModel.savePromotionFx.pending)

  const defaultValues = useStoreMap($promotion, (promotion) => {
    const attrs = promotion?.getAttributes()
    if (!attrs) return undefined

    const { carTypesTransmission, carTypesFuel, carCategories, ...restAttrs } =
      attrs

    return {
      ...restAttrs,
      carTypesTransmission: carTypesTransmission?.map(
        (item): OptionEnum<TransmissionEnum> => ({
          id: item as TransmissionEnum,
          label: transmissionLabels[item as TransmissionEnum],
        }),
      ),
      carTypesFuel: carTypesFuel?.map(
        (item): OptionEnum<FuelTypeEnum> => ({
          id: item as FuelTypeEnum,
          label: fuelTypeLabels[item as FuelTypeEnum],
        }),
      ),
      carCategories: carCategories?.map(
        (item): OptionEnum<CategoryAutoEnum> => {
          const enumValue =
            categoryAutoLabelToEnum[item] || (item as CategoryAutoEnum)
          return {
            id: enumValue,
            label: categoryAutoLabels[enumValue],
          }
        },
      ),
      regionsIds: promotion?.getRegions()?.map((region) => region.getOption()),
      carBrandsIds: promotion
        ?.getCarBrands()
        ?.map((carBrand) => carBrand.getOption()),
      carModelsIds: promotion
        ?.getCarModels()
        ?.map((carModel) => carModel.getOption()),
      carRegionsIds: promotion
        ?.getCarRegions()
        ?.map((region) => region.getOption()),
    }
  })

  return (
    <Grid xs={12}>
      <Form
        isLoading={isLoading}
        isSubmitting={isSaving}
        onSuccess={formSubmitted}
        defaultValues={defaultValues}
        canEdit={canPromocodesUpdate}
      />
    </Grid>
  )
}
